import { render, staticRenderFns } from "./createTagsForm.vue?vue&type=template&id=48554e7a&scoped=true"
import script from "./createTagsForm.vue?vue&type=script&lang=js"
export * from "./createTagsForm.vue?vue&type=script&lang=js"
import style0 from "./createTagsForm.vue?vue&type=style&index=0&id=48554e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48554e7a",
  null
  
)

export default component.exports